<template>
  <!--<button class="clientkey"  @click="showclientkey">
    <span v-show="!showkey">{{ linesConfigurator[0] }}</span>
    <span v-show="showkey"> {{ linesConfigurator[1]}}</span>
    <span style="color: orangered;font-weight: bold">@{{linesConfigurator[2]}}</span>
  </button>
  &nbsp;&nbsp;
  <span v-show="showkey" >{{client.key}}</span>
  -->
  <br>
  <span style="font-size: 20px;color: deeppink;margin-right: 10px;font-weight: bold"> {{client_name}}</span>
  <span style="font-size: 17px">{{ linesConfigurator[3] }}</span>
  <br><br>
  <span class="plan"> <i class="fa fa-credit-card-alt" aria-hidden="true"></i> {{client_plan}}</span>&nbsp;
  <span class="plan"><i class="fa fa-hourglass-start" aria-hidden="true"></i> {{tmsg}}</span>
  <button class="btn" @click="hexit">exit  <i class="fa fa-sign-out" aria-hidden="true"></i></button>
  <button v-show="this.client.update" class="btn" @click="updatePageConfig">
    <i class="fa fa-cloud-upload" aria-hidden="true"></i> {{linesConfigurator[4]}}
  </button>
  <div style="margin-top: 3vh">
    {{ linesConfigurator[5] }} <i class="fa fa-hand-o-right" aria-hidden="true"></i> <span style="color: #fa755a;font-weight: bold">{{client.b2b}}</span>
    <br><br>
    <label>
      <input :disabled="checkFreePlan" type="radio" value="[ Business to Client ]" v-model="client.b2b"  @change="changePageConfig">
      {{ linesConfigurator[6] }}
    </label>
    <label>
      <input :disabled="checkFreePlan" type="radio"  value="[ Business to Business ]" v-model="client.b2b" @change="changePageConfig">
      {{ linesConfigurator[7] }}
    </label>
    <br><br>
    {{ linesConfigurator[8] }} <i class="fa fa-hand-o-right" aria-hidden="true"></i> <span style="color: #fa755a;font-weight: bold">{{client.monthly}}</span>
    <br><br>
    <label>
      <input :disabled="checkFreePlan" type="radio" value="[ Monthly Fee ]" v-model="client.monthly" @change="changePageConfig">
      {{ linesConfigurator[9] }}
    </label>
    <label>
      <input :disabled="checkFreePlan" type="radio"  value="[ One Time Fee ]" v-model="client.monthly" @change="changePageConfig">
      {{ linesConfigurator[10] }}
    </label>
    <br><br>
    <button class="btn" style="margin-left: 2px" @click="preview">{{ linesConfigurator[11] }}</button>
    <br><br>
    <!-- update/create new customer on STRIPE  for payment feature -->
    <input :disabled="checkFreePlan" type="checkbox" v-model="client.csc" @change="changePageConfig">&nbsp;
    <span>
      {{linesConfigurator[23]}}
    </span>
    <br><br>
    <!--customer keys feature -->
    <input type="checkbox"  v-model="client.c_keys" disabled>
    <span>
      {{linesConfigurator[20]}}
    </span>
    <br>
    <span>[ {{ linesConfigurator[22] }} ]</span>
    <br><br>
    <button class="btn"  @click="customersKeys" :disabled="!checkGoldPlan">{{ linesConfigurator[21] }}</button>
    <br><br>
    <label>{{ linesConfigurator[12] }}</label>
    <br><br>
    <i id="plink" class="fa fa-link  icon" aria-hidden="true" ></i>
    <input class="input-field" type="text" placeholder="ex: http://www.ulip.ee" maxlength="50" v-model="client.weblink" @keyup="changePageConfig">
    <span style="font-size:12px;margin-left:5px">{{counter}}</span>
    <br>
    <button v-if="!showlink" class="confbtn" style="margin-left: 5px;margin-top: 10px" @click="generatelink" :disabled="!activateGenerateLink">
      {{ linesConfigurator[13] }}</button>
    <button v-else class="confbtn" style="margin-left: 5px;margin-top: 10px" @click="hidelink" >{{ linesConfigurator[14] }}</button>
    <div v-show="showlink">
      <br>
      <div style="display: block">
        <textarea  id="plink" class="paylink" v-model="gLink" rows="3"></textarea>
        &nbsp;<button class="btn" @click="copyToClip">Copy</button>
      </div>
      <br>
      <label for="plink">
        <i class="fa fa-check-square-o" aria-hidden="true"></i>
        {{ linesConfigurator[18] }}<span style="color: crimson"> [ {{payunit}} ] </span> & STRIPE {{ linesConfigurator[19] }} API <span style="color: crimson"> [ {{apitest}} ] </span>
      </label>
      <br>
      <label>
        <i class="fa fa-credit-card" aria-hidden="true"></i>
        {{ linesConfigurator[15] }}:
        <span style="color: crimson">{{ linesConfigurator[16] }}</span> [ {{payunit}} ] & <span style="color: crimson">STRIPE API</span> [ {{apitest}} ]
        <span style="font-weight: bold;font-size: 15px">{{ linesConfigurator[17] }}</span>
      </label>
    </div>
  </div>
</template>
<script>
import {getPageConfig} from "../translate";
import {getBaseURL} from "../../url_endpoints";
import {get_UPAYS_auth} from "@/components/hid";

export default {
  name: 'HerokuConfigurator',
  data() {
    return {
      expiration:null,
      interval:null,
      tmsg:'',
      client_name:'test',
      client_plan:'gold',
      client :{
        weblink:'',
        b2b:'[ Business to Business ]',
        monthly:'[ Monthly Fee ]',
        update:false,
        key:'',
        c_keys:true,
        csc:false, // create stripe customer
      },
      bid:1000000,
      ck:true,
      initclient:{},
      showkey:true,
      showlink:false,
      gLink:'',
      apitest:'sk_test_bfSJkRm9BflP2HfWgDqiUeoK',
      payunit:49,
      lang:0,
      linesConfigurator:['Your Access Key','Hide Access Key','keep it in a safe place',
        'Dashboard','update','Page Scope','Business 2 Client','Business 2 Business',
        'Payment type','Monthly Fee','One Time Fee','Preview your payment page',
        'Type Your App/Business Web Link where to redirect [ payment completed/cancellation ]',
        'PAYLink','Hide PAYLink','[ PROD mode ] Replace values of','pay unit','with your app values',
        '[ TEST mode ] PAYLink contains pay unit','test',
        'Generate SHA256 keys for your customers','View Keys','if your app/business needs auth process after payment',
        'Does payment create a customer on the STRIPE platform?'
      ]
    }
  },
  computed: {
    checkFreePlan() {
      return this.client_plan === 'free';
    },
    checkGoldPlan() {
      return this.client_plan === 'gold';
    },
    counter() {
      return this.client.weblink.length
    },
    activateGenerateLink() {
      return (this.client.weblink.length > 12 ) &&
          ((this.client.weblink.match("http://")||(this.client.weblink.match("https://")))) && !this.client.update
    }
  },
  created() {
    this.emitter.on('change_language', (evt) => {
      //console.log(evt.eventContent)
      if(evt.eventContent === '1') {
        this.linesConfigurator = getPageConfig(1)
        this.lang = 1
      }else {
        this.linesConfigurator = getPageConfig(0)
        this.lang = 0
      }
    })
    /* hide URL in order to protect client access key */
    history.pushState("/", "", "/hsso")
  },
  mounted(){
    this.setTimer2Hours()
    this.emitter.emit('heroku', {'eventContent': '1'})
    /* get heroku resource Data Base information */
    this.client_plan = !localStorage.getItem('plan') ? 'free' : localStorage.getItem('plan')
    /* get business id in order to extract the key list of business customers */
    this.bid = localStorage.getItem('bid')
    const localclient = localStorage.getItem('client')
    const b2b = !localclient ? 0 : (JSON.parse(localclient)).b2b
    const monthly = !localclient ? 0 : (JSON.parse(localclient)).monthly
    if(b2b === 1) {
      this.client.b2b = "[ Business to Client ]"
    }
    if(monthly === 1) {
      this.client.monthly = "[ One Time Fee ]"
    }
    if(!localclient) {
      this.client.weblink = ""
      this.client.csc = false
    }else {
      this.client.weblink = (JSON.parse(localclient)).weblink
      this.client.csc = (JSON.parse(localclient)).csc
    }
    // store initial configuration
    this.initclient = Object.assign({},this.client)
    this.client.key = !localStorage.getItem("akey") ? '666' : localStorage.getItem("akey")
    // customers keys
    this.client.c_keys = this.client_plan === 'gold'
    this.client_name = !localStorage.getItem('heroku_app') ? 'Undefined' : localStorage.getItem('heroku_app')
    this.startTimer()
  },
  methods: {
    copyToClip() {
      let wlink = this.gLink
      navigator.clipboard.writeText(wlink).then(function() {
        alert('Copy to clipboard');
      }, function(err) {
        alert('Copy failed: '+ err);
      })
    },
    setTimer2Hours() {
      /* set expiration time */
      this.expiration =  new Date().getTime();
      this.expiration+=(2*60*60*1000)  // hours * minutes * seconds * milliseconds
    },
    startTimer() {
      this.interval = setInterval(() => {
        // Get today's date and time
        let now = new Date().getTime();
        // Find the distance between now and the count down date
        let distance = this.expiration - now;
        // Time calculations for days, hours, minutes and seconds
        // let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // Output the result
        // this.tmsg = days + "d " + hours + "h " + minutes + "m " + seconds + "s "
        this.tmsg = hours + "h " + minutes + "m " + seconds + "s "
        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(this.interval);
          this.tmsg = "EXPIRED";
          setTimeout(() => {
            window.location.href = 'https://dashboard.heroku.com/apps/'+this.client_name
          },4000)
        }
      })
    },
    hexit(){
      window.location.href='https://dashboard.heroku.com/apps/'+this.client_name
    },
    customersKeys(){
      if(!this.bid) {
        alert('Server Internal problem')
        this.$router.push('/500')
      }else {
        this.$router.push({path:'/ckeys/a'+this.bid})
      }

    },
    formatWebLink() {
      return (this.client.weblink.match("http://") || this.client.weblink.match("https://")) && this.client.weblink.length > 12
    },
    computePLink(ref) {
      let basePL = ref.split('hsso')
      return basePL[0] + "payment/"+this.lang+'/'+this.client.key+"/"+this.payunit+"/"+ this.apitest
    },
    preview() {
      // compute preview page params
      let p1 = 1
      let p2 = 1
      if(this.client.b2b === "[ Business to Business ]"){
        p1 = 0
      }
      if(this.client.monthly === "[ Monthly Fee ]"){
        p2 = 0
      }
      localStorage.setItem('preview_ups','1')
      this.$router.push('/preview/'+p1+'/'+p2+'/'+this.lang)
    },
    generatelink() {
      this.gLink = this.computePLink(window.location.href)
      this.showlink = true
    },
    hidelink(){
      this.showlink = false
    },
    showclientkey() {
      this.showkey = !this.showkey
    },
    changePageConfig() {
      //console.log('changePageConfig')
      if( (this.client.b2b === this.initclient.b2b) &&
          (this.client.monthly === this.initclient.monthly) &&
          ( (this.client.weblink === this.initclient.weblink) || !this.formatWebLink() ) &&
          (this.client.csc === this.initclient.csc) ){
        this.client.update = false
      }else {
        this.client.update = true
      }
    },
    updatePageConfig() {
      /* first check if weblink is correct*/
      if( !this.formatWebLink()){
        this.client.weblink  = this.initclient.weblink
      }
      /* update payment page configurator for the client */
      let config = {
        b2b:this.client.b2b === "[ Business to Business ]" ? 0 : 1,
        monthly:this.client.monthly === '[ Monthly Fee ]' ? 0 : 1,
        weblink:this.client.weblink,
        csc: this.client.csc,
      }
      let statusCode = 401
      const update_api = this.client_plan === 'free' ? 'utrial/'+this.bid : 'uconfig/'+this.bid
      const baseURL = getBaseURL()
      const auth = get_UPAYS_auth()
      fetch(baseURL + '/clients/'+update_api, {
        method:'PUT',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type':'application/json'
        },
        body: JSON.stringify({config:config,key:this.client.key}),
      }).then(response => {
        //console.log(response.status);
        switch(response.status){
          case 401: statusCode = 401; break
          default: statusCode = 500
        }
        return response.json()
      }).then( rsp => {
        if(rsp['update']) {
          alert("Update successful!")
          this.client.update = false
          // store  the new configuration
          this.initclient = Object.assign({},this.client)
        }else {
          //alert("Error : update unsuccessful!")
          this.$router.push('/'+statusCode)
        }
      }).catch( (err) => {
        this.$router.push('/'+statusCode)
        throw new Error('Update resource ! - '+err.message)
      })
    }
  }
}
</script>
<style scoped>
/* Style the form icons */
.btn {
  background-color: black; /* Blue background */
  border: none; /* Remove borders */
  color: white; /* White text */
  padding: 5px 7px; /* Some padding */
  font-size: 12px; /* Set a font size */
  cursor: pointer; /* Mouse pointer on hover */
  border-radius: 8px;
  opacity: 0.7;
  margin-left: 5px;
}

/* Darker background on mouse-over */
.btn:hover {
  opacity: 0.9;
  background-color: lightpink;
  color:black;
}
.btn:disabled {
  background-color: lightslategray;
  cursor: not-allowed;
}
.icon {
  padding: 8px;
  background: #fa755a;
  color: white;
  min-width: 20px;
  text-align: center;
  border: 3px solid #fa755a;
}

/* Style the input fields */
.input-field {
  padding: 8px;
  outline: none;
  font-size: 15px;
  width: 30%;
}
.input-field:focus {
  border: 2px solid dodgerblue;
}
textarea {
  padding: 10px;
  border: lightslategray;
  font-size: 14px;
  background-color: lightblue;
}
.clientkey {
  color: black;
  font-size: 12px;
  font-weight: bold;
  border: 1px  solid lightslategray;
  background-color: #ffdddd;
  cursor: pointer;
  padding: 5px 5px;
  border-radius: 8px;
}
span {
  font-size: 12px;
  font-family: "Apple Braille", sans-serif;
}
.plan {
  font-size: 12px;
  color: black;
  font-family: "Apple Braille", sans-serif;
  margin-right: 10px;
  padding: 8px 8px ;
  background-color: lightgrey;
}
.upload {
  font-size: 14px;
  color: lightseagreen;
  opacity: 0.8;
  border-radius: 8px;
  border: none;
  background-color: white;
}
.upload:hover {
  cursor: pointer;
  font-size: 17px;
  color:green;
  opacity: 0.9;
}
.confbtn {
  font-size: 30px;
  padding: 10px 10px;
  border-radius: 8px;
  transform:
      perspective(600px)
      rotateX(60deg)
      scale(0.7);
  box-shadow: 0px 20px 100px #555;
  transition:0.5s ease all;

  &:hover {
    transform:
        rotate(0deg)
        scale(1)
        translateY(10px);
  }
}
.confbtn:disabled {
  cursor: not-allowed;
}
label {
  margin-left: 10px;
  font-size: 14px;
}
input:disabled {
  cursor: not-allowed;
}
.paylink {
  width: 40%;
  text-align: left;
  margin-top: 15px;
}
@media (max-width: 700px){
  .paylink {
    font-size: 10px;
    width: 90%;
  }
  label {
    font-size: 11px;
  }
  .input-field {
    width: 75%;
    font-size: 12px;
  }
  .icon {
    font-size: 12px;
  }
}
</style>
